import "./css/SigningFlow.css";
import { useParams, useNavigate } from "react-router-dom";

export default function MinorDisallowedScreen({
    flowData,
    updateFlowData,
    flowContext,
    updateFlowContext,
    next,
    back,
    loading,
    setLoading,
    error,
    setError,
}) {

    const navigate = useNavigate();

    const {
        businessLocationSlug,
        businessTypeSlug,
    } = useParams();

    const close = async () => {
        if (loading) return;

        setError("");

        const response = await next({
            action: "close"
        });

        if (response?.flowData?.navigateToServiceList) {
            navigate(
                `/start-waiver/${businessLocationSlug}/${businessTypeSlug}`
            );
        }
    };

    return (
        <div className={`page ${loading ? "page-loading" : ""}`}>
            
            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

            {error && (
                <div className="text-red-600 mt-2">
                    {error}
                </div>
            )}
            
            <div className="page-content warning-page">

                <div className="warning-icon warning-icon-danger"></div>

                <h2 className="warning-title">
                    Minors are not eligible for this waiver.
                </h2>

                <p className="warning-text">
                    This waiver can only be completed by an eligible adult.
                </p>

                <hr className="warning-divider" />

                 {/* <p className="warning-text">
                    If the date of birth is incorrect, return to your profile to update it before starting a new waiver.
                </p>

                <hr className="warning-divider" />

                <p className="warning-text">
                    Please select a different service or contact{" "}
                    {flowContext.business?.businessName || "[BUSINESS_NAME]"}{" "}
                    for further information.
                </p> */}

            </div>

            <div className="page-footer">

                <button
                    className="secondary-button"
                    onClick={close}
                    disabled={loading}
                >
                    Start Over
                </button>

            </div>

        </div>
    );
}